import StudyListIcon from "../nav-icons/StudyListIcon";
import AnalyticsIcon from "../nav-icons/AnalyticsIcon";
import NavIcons from "../nav-icons/NavIcons";
import AuditLogIcon from "../nav-icons/AuditLogIcon";
import ServerLogIcon from "../nav-icons/ServerLogIcon";
import SupervisorIcon from "../nav-icons/SupervisorIcon";
import ErrorIcon from "../nav-icons/ErrorIcon";
import ModalityIcon from "../nav-icons/ModalityIcon";
import BillingIcon from "../nav-icons/BillingIcon";
import HeaderReportTempIcon from "../nav-icons/HeaderReportTempIcon";
import { ACTIONS, AuthRoutes, USERTYPES } from "../../../constants/Constants";
import AdminUserIcon from "../nav-icons/AdminUserIcon";
import { AnnotationIcon } from "@fluentui/react-icons-mdl2";
import ReportTemplateIcon from "../nav-icons/ReportTemplateIcon";
import React,{useContext, useEffect,useState} from "react";
import userContext from "../../../context/users/UserContext";
import { t } from "i18next";
import { getEnv } from '../../../helpers/EnvHelper';

export const customNavbarTooltipStyles = {
  root: {
    backgroundColor: 'gray',
  },
};

export const mobileNavBarItems= (currentPath,roles,hoveredItem)=>{
  // const {roles } = useContext(userContext);
  let enterprise = (getEnv("REACT_APP_ENTERPRISE_PLATFORM")=="true"||getEnv("REACT_APP_ENTERPRISE_PLATFORM")==true)?true:false;
  let showMaster = (roles[0] == USERTYPES.ADMIN && !enterprise);
  let showOptios = {
    reportTemplate : roles[0] == USERTYPES.FIRMADMIN?true:false
  }
  let showProfile = roles[0] == USERTYPES.ADMIN || roles[0] == USERTYPES.FIRMADMIN || (roles.includes(USERTYPES.FIRMTECHNICIAN,USERTYPES.FIRMDOCTOR,USERTYPES.FIRMADMIN)
  && !enterprise) || (roles[0] == USERTYPES.RADIOLOGIST && !enterprise) 
|| (roles.includes(USERTYPES.FIRMTECHNICIAN,USERTYPES.FIRMDOCTOR) && enterprise);
// console.log("--- HoveredItem ---",hoveredItem);
hoveredItem = hoveredItem == null ? "": hoveredItem;
var showReport = roles[0] == USERTYPES.FIRMADMIN?true:false;
return [
        {
          id:"study-list",
          title: t("navbar.study-list"),
          icon: <NavIcons iconName="studylist" active={currentPath==AuthRoutes.STUDYLIST?true:false}/>,
          path: AuthRoutes.STUDYLIST,
          show: true,
          active: true,
          mobileBottomBar: true
        },
        {
            id:"account-settings",
            title: t("navbar.account-and-settings"),
            icon: <NavIcons iconName="account-settings" active={currentPath==AuthRoutes.ACCOUNTANDSETTINGS?true:false}/>,
            path: AuthRoutes.ACCOUNTANDSETTINGS,
            show: true,
            active: true,
            mobileBottomBar: true
        },
        {
            id:"more",
            title: t("navbar.more"),
            icon: <NavIcons iconName="more" active={currentPath==AuthRoutes.MOBILEMORE?true:false}/>,
            path: AuthRoutes.MOBILEMORE,
            show: true,
            active: true,
            mobileBottomBar: true
        },
    ]};
